import { render } from "./LoginModal.vue?vue&type=template&id=1cb72990&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=1cb72990&lang=less&scoped=true"

import exportComponent from "E:\\工作\\Owner项目\\在线考试系统\\web端\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb72990"]])

export default __exports__